export const checkNaN = (value) => {
  return isNaN(Number(value)) ? 0 : Number(Number(value).toFixed(0))
}
